import {Component, Input, OnChanges, OnInit, SimpleChanges,} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: "app-social-aspect",
  templateUrl: "./social-aspect.component.html",
  styleUrls: ["./social-aspect.component.scss"],
})
export class SocialAspectComponent implements OnInit, OnChanges {
  @Input() farmerInfo: FormGroup;
  @Input() formTabData: any; // Input property to receive formData from the parent component
  @Input() userFermenters: any;
  currentDate: Date;
  dateFormat = "dd/MM/yyyy";
  ownerInfo: FormGroup;
  coOwnerInfo: FormGroup;
  successorInfo: FormGroup;
  descendantsInfo: FormGroup[] = [];
  farmerTypes = [
    { key: 1, value: "Nông dân Marou" },
    { key: 2, value: "Nông dân bán trái" },
    { key: 3, value: "Dự án cây giống" },
  ];
  fermenterTypes = [
    { key: 11, value: "Lên men loại A" },
    { key: 12, value: "Lên men loại B" },
  ];
  gioiTinhOptions: string[] = ["Nam", "Nữ"];
  yeuThichCayCaCaoOptions: string[] = [
    "Phát triển thêm",
    "Giữ cây cacao",
    "Muốn thay đổi",
  ];
  yesNoOptions: string[] = ["Có", "Không"];
  khaNangSuDungUngDungOptions: string[] = [
    "Chính tôi",
    "Người đồng sở hữu",
    "Người nối nghiệp",
    "Không",
  ];
  dantocOptions: string[] = [
    "Kinh",
    "Tày",
    "K'Ho",
    "Nùng",
    "Hoa",
    "Ê Đê",
    "Khác",
  ];
  moiQuanHeVoiChuVuonOptions: string[] = ["Vợ", "Chồng", "Con", "Cháu"];
  moiQuanHeVoiChuVuonConChauOptions: string[] = ["Con", "Cháu"];
  noiOOptions: string[] = ["Cùng với chủ vườn", "Không cùng với chủ vườn"];
  caphocOptions: string[] = ["Tiểu học", "THCS", "THPT", "CĐ-ĐH"];

  constructor(private fb: FormBuilder) {}

  submitForm() {
    if ((!this.coOwnerInfo.value.hoVaTen) || this.coOwnerInfo.value.hoVaTen === '') {
      this.coOwnerInfo.get('ngayGhiNhan').setValue(null);
    }
    if (!this.successorInfo.value.hoVaTen || this.successorInfo.value.hoVaTen === '') {
      this.successorInfo.get('ngayGhiNhan').setValue(null);
    }
    return {
      ownerInfoForm: this.serializeFormGroup(this.ownerInfo),
      coOwnerInfoForm: this.serializeFormGroup(this.coOwnerInfo),
      successorInfoForm: this.serializeFormGroup(this.successorInfo),
      descendantsInfoForm: this.descendantsInfo.map((formGroup) => {
        if (!formGroup.value.hoVaTen || formGroup.value.hoVaTen === '') {
          formGroup.get('ngayGhiNhan').setValue(null);
        }
        return this.serializeFormGroup(formGroup);
          }
      ),
    };
  }

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }

  ngOnInit(): void {
    this.currentDate = new Date();
    if (!this.ownerInfo) {
      this.initializeOwnerInfoFormGroup();
    }
    if (!this.coOwnerInfo) {
      this.initializeCoOwnerInfoFormGroup();
    }
    if (!this.successorInfo) {
      this.initializeSuccessorInfoFormGroup();
    }
    if (this.descendantsInfo.length === 0) {
      this.addDescendantsInfoForm();
    }
    this.coOwnerInfo.get("danToc").valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.coOwnerInfo.get("customDanToc").setValue(null);
      }
    });

    this.successorInfo
      .get("danToc")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.successorInfo.get("customDanToc").setValue(null);
        }
      });

    this.ownerInfo
      .get("nguoiDongSoHuu")
      .valueChanges.subscribe((selecteOption) => {
        if (selecteOption === "Không") {
          this.coOwnerInfo.setValue(null);
        }
      });

    this.ownerInfo
      .get("nguoiNoiNghiep")
      .valueChanges.subscribe((selecteOption) => {
        if (selecteOption === "Không") {
          this.successorInfo.setValue(null);
        }
      });
    for (let index = 0; index < this.descendantsInfo.length; index++) {
      const danTocControl = this.descendantsInfo[index].get("danToc");

      danTocControl.valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.descendantsInfo[index].get("customDanToc").setValue(null);
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.farmerInfo) {
      // ngOnChanges runs before ngOnInit, so local forms may not exist yet.
      if (!this.ownerInfo) {
        this.currentDate = this.currentDate || new Date();
        this.initializeOwnerInfoFormGroup();
      }

      if (this.ownerInfo && this.farmerInfo) {
        this.farmerInfo.valueChanges.subscribe((changes) => {
        if (changes.userCode) {
          this.ownerInfo.get("maNongDan").setValue(changes.userCode);
        }
        if (changes.fullName) {
          this.ownerInfo.get("hoVaTen").setValue(changes.fullName);
        }
        if (changes.phoneNumber) {
          this.ownerInfo.get("soDienThoai").setValue(changes.phoneNumber);
        }
        if (changes.address) {
          this.ownerInfo.get("diaChi").setValue(changes.address);
        }
        if (changes.gender) {
          this.ownerInfo.get("gioiTinh").setValue(changes.gender);
        }
        if (changes.birthYear) {
          this.ownerInfo.get("namSinh").setValue(changes.birthYear);
        }
        if (changes.userType) {
          this.ownerInfo.get("phanLoaiNongDan").setValue(changes.userType);
        }
        if (changes.fermenterId) {
          this.ownerInfo.get("nguoiLenMen").setValue(changes.fermenterId);
        }
        if (changes.locate) {
          this.ownerInfo.get("dinhVi").setValue(changes.locate);
        }

        // Add more conditions for other fields if needed
        });
      }
    }

    if (
      (changes.formTabData || (changes.farmerInfo && changes.farmerInfo.firstChange)) &&
      this.formTabData
    ) {
      if (!this.ownerInfo) {
        this.currentDate = this.currentDate || new Date();
        this.initializeOwnerInfoFormGroup();
      }

      if (!this.ownerInfo) {
        return;
      }

      this.ownerInfo.reset();
      this.initializeCoOwnerInfoFormGroup();
      this.initializeSuccessorInfoFormGroup();
      this.descendantsInfo = [];
      this.addDescendantsInfoForm();
    try {
      // Parse JSON data from formTabData
      if (this.formTabData.phuongDienXaHoi) {
        const trimmedJsonString = this.formTabData.phuongDienXaHoi.trim();
        const socialAspectData = JSON.parse(trimmedJsonString);
        if (socialAspectData) {
          this.setFormValues(this.ownerInfo, socialAspectData.ownerInfoForm);
          this.setFormValues(
            this.coOwnerInfo,
            socialAspectData.coOwnerInfoForm
          );
          this.setFormValues(
            this.successorInfo,
            socialAspectData.successorInfoForm
          );
          if (Array.isArray(socialAspectData.descendantsInfoForm)) {
            if (socialAspectData.descendantsInfoForm.length === 0) {
              this.descendantsInfo = [this.createDescendantsInfoForm()];
            } else {
              this.descendantsInfo = socialAspectData.descendantsInfoForm.map((descendant) => {
                const formGroup = this.createDescendantsInfoForm();
                this.setFormValues(formGroup, descendant);
                return formGroup;
              });
            }
          }
        }
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
      // Handle the error or provide appropriate fallback behavior
    }}
  }

  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }

  private initializeOwnerInfoFormGroup() {
    if (
      this.farmerInfo &&
      this.farmerInfo.get("userCode") &&
      this.farmerInfo.get("fullName")
    ) {
      this.ownerInfo = this.fb.group({
        ngayGhiNhan: [this.currentDate],
        maNongDan: [this.farmerInfo.get("userCode").value, Validators.required],
        hoVaTen: [this.farmerInfo.get("fullName").value, Validators.required],
        soDienThoai: [this.farmerInfo.get("phoneNumber").value, Validators.required],
        diaChi: [this.farmerInfo.get("address").value, Validators.required],
        dinhVi: [this.farmerInfo.get("locate").value, Validators.required],
        gioiTinh: [this.farmerInfo.get("gender").value, Validators.required],
        namSinh: [this.farmerInfo.get("birthYear").value, Validators.required],
        danToc: [null, Validators.required],
        phanLoaiNongDan: [this.farmerInfo.get("userType").value, Validators.required],
        nguoiLenMen: [this.farmerInfo.get("fermenterId").value, Validators.required],
        yeuThichCayCacao: [null, Validators.required],
        khamSucKhoeDinhKy: [null, Validators.required],
        theBaoHiemYTe: [null, Validators.required],
        khaNangSuDungUngDung: [null, Validators.required],
        nguoiDongSoHuu: [null, Validators.required],
        nguoiNoiNghiep: [null, Validators.required],
      });
    }

  }

  private initializeCoOwnerInfoFormGroup() {
    this.coOwnerInfo = this.fb.group({
      ngayGhiNhan: [this.currentDate, []],
      hoVaTen: [null, Validators.required],
      soDienThoai: [null],
      gioiTinh: [null],
      namSinh: [null],
      danToc: [null],
      customDanToc: [""],
      moiQuanHeVoiChuVuon: [null, Validators.required],
      yeuThichCayCaCao: [null, Validators.required],
      quyetDinhCanhTacCacao: [null, Validators.required],
    });
  }

  private initializeSuccessorInfoFormGroup() {
    this.successorInfo = this.fb.group({
      ngayGhiNhan: [this.currentDate],
      hoVaTen: [null, Validators.required],
      soDienThoai: [null],
      gioiTinh: [null],
      namSinh: [null],
      danToc: [null],
      customDanToc: [""],
      moiQuanHeVoiChuVuon: [null, Validators.required],
      namTiepQuan: [null],
      yeuThichCayCaCao: [null, Validators.required],
    });
  }

  createDescendantsInfoForm(): FormGroup {
    return this.fb.group({
      ngayGhiNhan: [this.currentDate, []],
      hoVaTen: ["", Validators.required],
      gioiTinh: [""],
      namSinh: [""],
      danToc: [""],
      customDanToc: [""],
      moiQuanHeVoiChuVuon: ["", Validators.required],
      noiO1: ["", Validators.required],
      caphoc: [""],
      lop: [""],
      truong: [""],
      thanhTich: [""],
    });
  }

  // Function to add a new descendantsInfo form
  addDescendantsInfoForm() {
    this.descendantsInfo.push(this.createDescendantsInfoForm());
  }

  // Function to remove a descendantsInfo form at a specific index
  removeDescendantsInfoForm(index: number) {
    this.descendantsInfo.splice(index, 1);
  }

  isObjectEmpty(obj: any): boolean {
    return obj !== null && Object.keys(obj).length === 0;
  }
  
  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
}
